import { IGatsbyImageData } from 'gatsby-plugin-image';

export enum ALIGN_IMAGE {
  LEFT = 'left',
  RIGHT = 'right',
}
export interface AlignedImageBlockProps {
  title: string;
  anchorId?: string;
  content?: any; // TODO: this will need to share types from the Rich Text Block once that is typed
  imageSrc: string;
  imageAlt?: string;
  gatsbyImageData: IGatsbyImageData;
  format?: string;
  alignImage: ALIGN_IMAGE;
  imageLink?: string;
  imageOpenInNewTab?: boolean;
  internalImageLink?: string;
  mediaUrl?: string;
  firstButtonLink?: string;
  firstButtonText?: string;
  secondButtonLink?: string;
  secondButtonText?: string;
}
